import Conditional from '@next-app/components/Conditional';
import Image from 'next/image';
import LLButton from '@next-app/components/elements/LLButton/LLButton';
import { selectIsFurniture } from '@next-app/lib/features/InitSelectors';
import { useSelector } from 'react-redux';

const CollapseBox = ({
  showCollapse,
  setShowCollapse,
  children,
  mobileView,
  isDisabled = false,
  customClass,
  childClass,
  hideExpandButton,
}: {
  showCollapse: boolean;
  setShowCollapse: Function;
  children: React.ReactNode;
  mobileView?: boolean;
  isDisabled?: boolean;
  customClass?: string;
  childClass?: string;
  hideExpandButton?: boolean;
}) => {
  const isFurniture = useSelector(selectIsFurniture);
  return (
    <Conditional if={!showCollapse}>
      <div
        className={`d-flex justify-content-between  ${isDisabled ? 'opacity-50' : ''} ${mobileView ? `hide-md-brd-rond-start-end py-ll-3 px-md-ll-3` : 'p-ll-3 border rounded'} ${isFurniture ? 'rounded-0' : ''} ${customClass}`}
      >
        <div className={`w-100 overflow-hidden ${childClass}`}>{children}</div>
        <Conditional if={!hideExpandButton}>
          <div>
            <LLButton
              customClass="arrow-btn down"
              onClick={() => {
                setShowCollapse();
              }}
              disabled={isDisabled}
            >
              <Image
                src="/react/assets/icons/arrow-down-heavy.svg"
                alt="down-arrow"
                height="12"
                width="12"
                unoptimized={true}
              />
            </LLButton>
          </div>
        </Conditional>
      </div>
    </Conditional>
  );
};

export default CollapseBox;
